import React from "react";
import WebHeader from "../Header";
import WebFooter from "../Footer";
import Background from "../Background";
import "../../App.css?v=1";





const MainLayout = ({ children }) => {
  return (
    <>
      {/* Background */}
      <Background />

      {/* Header */}
      <WebHeader />

      {/* Page Content */}
      <main className="main-content"><div className="inner-div"> {children}</div></main>

      {/* Footer */}
      <WebFooter />
    </>
  );
};

export default MainLayout;
